"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConfiguration = void 0;
const createConfiguration = (initialConfiguration) => {
    let Configuration = initialConfiguration;
    const setConfigurationLib = (newConfiguration = {}) => {
        Configuration = Object.assign(Object.assign({}, Configuration), newConfiguration);
    };
    const getConfigurationLib = () => (Object.assign({}, Configuration));
    return { setConfigurationLib, getConfigurationLib };
};
exports.createConfiguration = createConfiguration;
//# sourceMappingURL=index.js.map